module.exports = __webpack_public_path__ + "img/wcsc.e68b9a7a.png";